var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.794%",
    y1: "93.362%",
    x2: "50.794%",
    y2: "12.41%",
    id: "cus57esgua"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CBD2A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BF675",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#cus57esgua)",
    width: 44,
    height: 44,
    rx: 9.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 7.617c-8.92 0-16.15 6.022-16.15 13.451.008 4.72 2.986 9.092 7.846 11.519-.636 1.425-1.59 2.76-2.824 3.953 2.391-.42 4.636-1.302 6.56-2.577 1.482.367 3.02.555 4.568.557 8.92 0 16.15-6.022 16.15-13.452 0-7.429-7.23-13.451-16.15-13.451z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.fd84e5bb970ad4e41364e82579cda736.svg";
export { ForwardRef as ReactComponent };